import React, { ReactNode } from 'react'
import { Fixed } from '../../bases/Fixed'
import { VStack } from '../../bases/VStack'
import {
  Layout as GlobalNavigationHeader,
  Props as GlobalNavigationHeaderProps,
} from '../GlobalNavigationHeader/Layout'
import {
  Layout as GlobalNavigationMenu,
  Props as GlobalNavigationMenuProps,
} from '../GlobalNavigationMenu/Layout'

export type Props = {
  GlobalNavigationMenuProps: GlobalNavigationMenuProps
  GlobalNavigationHeaderProps: GlobalNavigationHeaderProps
  children?: ReactNode
}

export const Layout: React.FC<Props> = (props) => {
  return (
    <VStack className="min-h-screen w-full">
      <Fixed className="top-0 left-0 z-20 h-14 w-full">
        <GlobalNavigationHeader {...props.GlobalNavigationHeaderProps} />
      </Fixed>
      <Fixed className="top-0 left-0 z-20 h-screen w-72 pt-14">
        <GlobalNavigationMenu {...props.GlobalNavigationMenuProps} />
      </Fixed>
      <VStack className="z-10 min-h-screen w-full flex-1 pt-14 pl-72">
        <VStack className="z-10 h-full w-full max-w-[1720px] flex-1">{props.children}</VStack>
      </VStack>
    </VStack>
  )
}
